import { subscribe, dispatch, unsubscribe } from "./modules/Whatsub";
import { LanguageSwitcherController } from './controllers/LanguageSwitcherController';
import { ProductTabsController } from './controllers/ProductTabsController';
import ProductModule from "./modules/product/Module";
import AccountController from "./controllers/AccountController";

window.addEventListener('load', () => {
  window.WhatSub = {
    subscribe: subscribe,
    dispatch: dispatch,
    unsubscribe: unsubscribe,
  };

  LanguageSwitcherController();
  ProductTabsController();
  AccountController();

  ProductModule();
});



// WEBPACK FOOTER //
// ./src/js/app.js